import { render } from "./ResponseModal.vue?vue&type=template&id=f5b45adc&scoped=true"
import script from "./ResponseModal.vue?vue&type=script&lang=js"
export * from "./ResponseModal.vue?vue&type=script&lang=js"

import "./ResponseModal.vue?vue&type=style&index=0&id=f5b45adc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5b45adc"]])

export default __exports__